module.exports = __webpack_public_path__ + "img/multiline.5f30c12d.svg";